  import { useEffect, useState,useContext } from "react";
  import "bootstrap/dist/css/bootstrap.min.css";
  import API from "../api/Api";
import { AppContext } from "../context/Context";
import { BASE_URL } from "../api/Api";
  import { useNavigate } from "react-router-dom";
const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;
const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;


  export default function RegistrationForm() {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("register");
    const [flashMessage, setFlashMessage] = useState({ type: "", text: "" });
    const [showLoginPass, setShowLoginPass] = useState(false);
    const [showRegPass, setShowRegPass] = useState(false);
    const [showRegConf, setShowRegConf] = useState(false);
    const [userType, setUserType] = useState("Corporate");
    const [districts, setDistricts] = useState([]);
    const [states, setStates] = useState([]);
    const [regErrors, setRegErrors] = useState({});

    const { siteSetting, loading } = useContext(AppContext);


  const showFlashMessage = (type, text) => {
    setFlashMessage({ type, text });
  };

  const clearFlashMessage = () => {
    setFlashMessage({ type: "", text: "" });
  };

  const getMissingLoginFields = () => {
    const missingFields = [];

    if (!loginData.email.trim()) missingFields.push("Email");
    if (!loginData.password.trim()) missingFields.push("Password");

    return missingFields;
  };

  const requiredMessage = (label) => `${label} is required`;

  const getRegistrationErrors = () => {
  const errors = {};

  if (!regData.fullName.trim()) {
    errors.fullName = requiredMessage("Full Name");
  } else if (!/^[A-Za-z\s]+$/.test(regData.fullName)) {
    errors.fullName = "Full Name should contain only letters";
  }

 if (!regData.email.trim()) {
  errors.email = requiredMessage("Email Address");
} else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(regData.email)) {
  errors.email = "Enter a valid email address (e.g. user@gmail.com)";
}
if (!regData.phoneNumber.trim()) {
  errors.phoneNumber = requiredMessage("Phone Number");
} else if (!/^[0-9]+$/.test(regData.phoneNumber)) {
  errors.phoneNumber = "Phone Number must contain only digits";
} else if (regData.phoneNumber.length !== 10) {
  errors.phoneNumber = "Phone Number must be exactly 10 digits";
}

  if (!regData.state) errors.state = requiredMessage("State");
  if (!regData.district) errors.district = requiredMessage("District");
  if (!regData.password.trim()) errors.password = requiredMessage("Password");
  if (!regData.confirmPassword.trim()) errors.confirmPassword = requiredMessage("Confirm Password");

  if (userType === "Corporate") {
    if (!regData.interestType) errors.interestType = requiredMessage("Interest Type");
    if (!regData.organizationType) errors.organizationType = requiredMessage("Organization Type");
  if (!regData.gstNumber.trim()) {
  errors.gstNumber = requiredMessage("GST Number");
} else if (
  !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(regData.gstNumber)
) {
  errors.gstNumber = "Invalid GST Number format (e.g. 22AAAAA0000A1Z5)";
}
  }

if (userType === "NGO") {

  if (!regData.panNumber.trim()) {
    errors.panNumber = requiredMessage("PAN Number");

  } else if (
    !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(
      regData.panNumber.toUpperCase()
    )
  ) {
    errors.panNumber =
      "Invalid PAN Number format (e.g. ABCDE1234F)";
  }

  if (!regData.registrationNumber.trim()) {
    errors.registrationNumber =
      requiredMessage("Registration Number");
  }
}
if (
  regData.password &&
  regData.confirmPassword &&
  regData.password !== regData.confirmPassword
) {
  errors.confirmPassword = "Confirm Password does not match the Password";
}
if (!regData.agreeTerms) {
  errors.agreeTerms = "You must accept Terms & Privacy Policy";
}
  return errors;
};
const getDistricts = (state_id) => {
  API.get(`/districts?state_id=${state_id}`)
    .then((res) => {
      if (res.data.success) {
        setDistricts(res.data.data);

        const pune = res.data.data.find(d => d.name === "Pune");
        if (pune) {
          setRegData(prev => ({
            ...prev,
            district: pune.name
          }));
        }
      }
    })
    .catch((err) => console.error(err));
};

  // login state 
    const handleLoginChange = (e) => {
      const { name, value } = e.target;
      setLoginData((prevData) => ({
        ...prevData,
        [name]: value
      }));
    };
    const [loginData, setLoginData] = useState({
      email: "",
      password: ""
    });
   
  // login submit
    const handleLoginSubmit = async(e) => {
      e.preventDefault();
      const missingFields = getMissingLoginFields();

      if (missingFields.length > 0) {
        showFlashMessage("danger", `Please fill required fields: ${missingFields.join(", ")}`);
        return;
      }

      try{
        const res = await API.post("/login", loginData);
        if(res.data.success){
          showFlashMessage("success", res.data.message || "Login successful");
          localStorage.setItem("user", JSON.stringify(res.data.data));
          localStorage.setItem("token", res.data.token);
          setTimeout(() => {
            navigate("/");
          }, 800);
        }else {
          showFlashMessage("danger", res.data.message || "Login failed");
        }
      }catch(err){
        showFlashMessage("danger", err.response?.data?.message || "Login failed");
        
      } 
    }
  const getStates = () => {
  API.get("/states")
    .then((res) => {
      if (res.data.success) {
        setStates(res.data.data);
      }
    })
    .catch((err) => console.error(err));
};
const getInputClass = (fieldName) => {
  return `form-control csr-input ${regErrors[fieldName] ? "is-invalid" : ""}`;
};

const renderFieldError = (fieldName) => {
  return regErrors[fieldName] ? (
    <div className="invalid-feedback">{regErrors[fieldName]}</div>
  ) : null;
};

  const handleRegChange = (e) => {
  const { name, value, type, checked } = e.target;
  const val = type === "checkbox" ? checked : value;

  if (name === "agreeTerms") {
    setRegData((prev) => ({
      ...prev,
      agreeTerms: checked
    }));

    setRegErrors((prev) => {
      const next = { ...prev };
      delete next.agreeTerms;
      return next;
    });

    return;
  }


  if (name === "fullName") {
    if (!/^[A-Za-z\s]*$/.test(value)) return;
  }

  if (name === "phoneNumber") {
    if (!/^[0-9]*$/.test(value) || value.length > 10) return;
  }

  if (regErrors[name]) {
    setRegErrors((prev) => {
      const nextErrors = { ...prev };
      delete nextErrors[name];
      return nextErrors;
    });
  }

  if (name === "state") {
    setRegData((prev) => ({
      ...prev,
      state: val,
      district: ""
    }));

    if (name === "panNumber") {

  const panValue = value.toUpperCase();

  setRegData((prev) => ({
    ...prev,
    panNumber: panValue,
  }));

  const panRegex =
    /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

  if (panValue && !panRegex.test(panValue)) {
    setRegErrors((prev) => ({
      ...prev,
      panNumber:
        "Invalid PAN Number format (e.g. ABCDE1234F)",
    }));
  } else {
    setRegErrors((prev) => {
      const next = { ...prev };
      delete next.panNumber;
      return next;
    });
  }

  return;
}

    if (name === "password" || name === "confirmPassword") {
  const newPassword =
    name === "password" ? value : regData.password;

  const newConfirm =
    name === "confirmPassword" ? value : regData.confirmPassword;

  if (newPassword && newConfirm && newPassword !== newConfirm) {
    setRegErrors((prev) => ({
      ...prev,
      confirmPassword: "Confirm Password does not match the Password"
    }));
  } else {
    setRegErrors((prev) => {
      const next = { ...prev };
      delete next.confirmPassword;
      return next;
    });
  }
}

if (name === "email") {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (value && !emailRegex.test(value)) {
    setRegErrors((prev) => ({
      ...prev,
      email: "Invalid email format"
    }));
  } else {
    setRegErrors((prev) => {
      const next = { ...prev };
      delete next.email;
      return next;
    });
  }
}

    setRegErrors((prev) => {
      const nextErrors = { ...prev };
      delete nextErrors.state;
      delete nextErrors.district;
      return nextErrors;
    });
  } else {
    setRegData((prev) => ({
      ...prev,
      [name]: val
    }));
  }
};
   const [regData, setRegData] = useState({
  fullName: "",
  email: "",
  phoneNumber: "",
  state: "1",  
  district: "1",     
  interestType: "",
  organizationType: "",
  gstNumber: "",
  panNumber: "",
  registrationNumber: "",
  password: "",
  confirmPassword: "",
  agreeTerms: false
});
    // console.log(regData);
    // registration submit  
  const handleRegSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = getRegistrationErrors();

    if (Object.keys(validationErrors).length > 0) {
      setRegErrors(validationErrors);
      showFlashMessage("danger", "Please fill all required fields");
      return;
    }
    setRegErrors({});

    try {
      const payload = {
        user_type: userType,
        name: regData.fullName,
        email: regData.email,
        mobile: regData.phoneNumber,
        state: regData.state,
        district: regData.district,

        interest_type: regData.interestType,
        organization_type: regData.organizationType,
        gst_no: regData.gstNumber,

        pan_no: regData.panNumber,
        registration_no: regData.registrationNumber,

        password: regData.password
      };
      // console.log(payload);

      const res = await API.post("/registration", payload);
      alert(res.data?.message || "Registration successful. Please login to continue.");

      window.location.href = `${LOGIN_URL}`;

      showFlashMessage("success", res.data?.message || "Registration successful");
    } catch (err) {
      showFlashMessage("danger", err.response?.data?.message || "Registration failed");
  const errorMsg = err.response?.data?.message || "Registration failed";

  // ✅ show alert popup
  alert(errorMsg);

  // optional flash
  showFlashMessage("danger", errorMsg);
}

    
  };

useEffect(() => {
  getStates();
}, []);

useEffect(() => {
  if (regData.state) {
    getDistricts(regData.state);
  }
}, [regData.state]);

useEffect(() => {
  if (!flashMessage.text) return;

  const timer = setTimeout(() => {
    clearFlashMessage();
  }, 4000);

  return () => clearTimeout(timer);
}, [flashMessage]);

    return (
      <div className="auth-csr-auth-wrapper d-flex align-items-start justify-content-center py-5">
        <div className="container" style={{ maxWidth: 820 }}>


          {flashMessage.text && (
            <div
              className={`alert alert-${flashMessage.type} alert-dismissible fade show`}
              role="alert"
            >
              {flashMessage.text}
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={clearFlashMessage}
              ></button>
            </div>
          )}

          {/* CARD */}
          <div className="card csr-card shadow-sm border-0">
            <div className="text-center register-header">
  <h2 className="auth-register-title">
    Create Your Account
  </h2>

  <p className="auth-register-subtitle">
    Register as Corporate, NGO / Implementing Partner
    <br />
    or Individual / Volunteer
  </p>
 {siteSetting?.logo3 && (
  <img
    src={`${BASE_URL}/assets/images/${siteSetting.logo3}`}
    alt="Register"
    className="auth-register-image"
  />
)}
</div>


            {/* TABS */}
            <div className="auth-csr-tabs d-flex border-bottom">
              
              <button
                className={`csr-tab-btn flex-fill ${activeTab === "register" ? "active" : ""}`}
                onClick={() => setActiveTab("register")}
              >
                Register
              </button>
            </div>

            {/* LOGIN */}
            {/* {activeTab === "login" && (
              <div className="card-body">
                <form onSubmit={handleLoginSubmit}>
                  <div className="mb-3">
                    <label className="form-label csr-label">Email Address *</label>
                    <input
                      type="email"
                      className="form-control csr-input"
                      placeholder="your.email@example.com"
                      name="email"
                      value={loginData.email}
                      onChange={handleLoginChange}
                    />
                  </div>

                  <div className="mb-3 position-relative">
                    <label className="form-label csr-label">Password *</label>
                    <input
                      type={showLoginPass ? "text" : "password"}
                      className="form-control csr-input"
                      placeholder="Enter your password"
                      name="password"
                      value={loginData.password}
                      onChange={handleLoginChange}
                    />
                    <span
                      className="auth-csr-eye"
                      onClick={() => setShowLoginPass(!showLoginPass)}
                    >
                      👁
                    </span>
                  </div>

                  <div className="d-flex align-items-center mb-3">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" />
                      <label className="form-check-label csr-muted">
                        Remember me
                      </label>
                    </div>
                    <a href="#" className="ms-auto csr-link">
                      Forgot Password?
                    </a>
                  </div>

                  <button className=" btn auth-csr-btn w-100">Sign In</button>

                  <p className="text-center csr-muted mt-3 mb-0">
                    Don’t have an account?{" "}
                    <span
                      className="auth-csr-link"
                      onClick={() => setActiveTab("register")}
                    >
                      Register here
                    </span>
                  </p>
                </form>
              </div>
            )} */}

            {/* REGISTER */}
            {activeTab === "register" && (
              <div className="card-body">
                <form onSubmit={handleRegSubmit}>
                  {/* USER TYPES */}
               <div className="row g-3 mb-4">

  <div className="col-md-6">
    <div
      className={`auth-csr-user-type ${userType === "Corporate" ? "active" : ""}`}
      onClick={() => {
        setUserType("Corporate");
        setRegErrors({});
      }}
    >
      <i className="fas fa-building"></i>
      <span>Corporate</span>

      {userType === "Corporate" && (
        <i className="fas fa-check-circle auth-csr-check"></i>
      )}
    </div>
  </div>

  <div className="col-md-6">
    <div
      className={`auth-csr-user-type ${userType === "NGO" ? "active" : ""}`}
      onClick={() => {
        setUserType("NGO");
        setRegErrors({});
      }}
    >
      <i className="fas fa-users"></i>
      <span>NGO / Implementing Partner</span>

      {userType === "NGO" && (
        <i className="fas fa-check-circle auth-csr-check"></i>
      )}
    </div>
  </div>

  <div className="col-12">
    
    <div
      className={`auth-csr-user-type auth-csr-full-width ${
        userType === "Individual" ? "active" : ""
      }`}
      onClick={() => {
        setUserType("Individual");
        setRegErrors({});
      }}
    >
      <i className="fas fa-user"></i>
      <span>Individual / Volunteer</span>

      {userType === "Individual" && (
        <i className="fas fa-check-circle auth-csr-check"></i>
      )}
    </div>
  </div>

</div>

                  <div className="row g-3">
                    <div className="col-md-6">
                    <label className="form-label csr-label">
  Full Name <span style={{ color: "red" }}>*</span>
</label>
                      <input className={getInputClass("fullName")} name="fullName" value={regData.fullName} onChange={handleRegChange} placeholder="Enter your full name" />
                      {renderFieldError("fullName")}
                    </div>
                    <div className="col-md-6">
                      <label className="form-label csr-label">
  Email Address <span style={{ color: "red" }}>*</span>
</label>
                      <input className={getInputClass("email")} name="email" value={regData.email} onChange={handleRegChange} placeholder="your.email@example.com" />
                      {renderFieldError("email")}
                    </div>

                    <div className="col-md-6">
                      <label className="form-label csr-label">
  Phone Number <span style={{ color: "red" }}>*</span>
</label>
                      <input className={getInputClass("phoneNumber")} name="phoneNumber" value={regData.phoneNumber} onChange={handleRegChange} placeholder="1234567890" />
                      {renderFieldError("phoneNumber")}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label csr-label">
  State <span style={{ color: "red" }}>*</span>
</label>
         <select
  className={getInputClass("state")}
  name="state"
  value={regData.state}
  onChange={handleRegChange}
>
  <option value="">Select State</option>
  {states.map((s) => (
    <option key={s.state_id} value={s.state_id}>
      {s.name}
    </option>
  ))}
</select>
{renderFieldError("state")}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label csr-label">
  District <span style={{ color: "red" }}>*</span>
</label>
 <select
  className={getInputClass("district")}
  name="district"
  value={regData.district}
  onChange={handleRegChange}
>
  <option value="">Select District</option>
  {districts.map((d) => (
    <option key={d.district_id} value={d.district_id}>
      {d.name}
    </option>
  ))}
</select>
{renderFieldError("district")}              </div>

                    {/* CORPORATE EXTRA FIELDS */}
  {userType === "Corporate" && (
    <>
      <div className="col-md-6">
        <label className="form-label csr-label">
  Intrest Type <span style={{ color: "red" }}>*</span>
</label>
        <select className={getInputClass("interestType")} name="interestType" value={regData.interestType} onChange={handleRegChange}>
          <option value="">Select Interest</option>
          <option value="EXECUTOR">Executer</option>
          <option value="FUNDER">Funder</option>
        
        </select>
        {renderFieldError("interestType")}
      </div>

      <div className="col-md-6">
       <label className="form-label csr-label">
  Organization Type <span style={{ color: "red" }}>*</span>
</label>
        <select className={getInputClass("organizationType")} name="organizationType" value={regData.organizationType} onChange={handleRegChange}>
          <option value="">Select Organization Type</option>
          <option value="private_limited">Private Limited</option>
          <option value="public_limited">Public Limited</option>
          <option value="llp">LLP</option>
          <option value="partnership">Partnership</option>
        </select>
        {renderFieldError("organizationType")}
      </div>

      <div className="col-md-6">
       <label className="form-label csr-label">
  GST Number <span style={{ color: "red" }}>*</span>
</label>
        <input
          type="text"
          className={getInputClass("gstNumber")}
          name="gstNumber"
          value={regData.gstNumber}
          onChange={handleRegChange}
          placeholder="Enter GST Number"
        />
        {renderFieldError("gstNumber")}
      </div>
    </>
  )}

  {/* NGO EXTRA FIELDS */}
  {userType === "NGO" && (
    <>
      <div className="col-md-6">
        <label className="form-label csr-label">
  PAN Number <span style={{ color: "red" }}>*</span>
</label>
        <input
          type="text"
          className={getInputClass("panNumber")}
          name="panNumber"
          value={regData.panNumber}
          onChange={handleRegChange}
          placeholder="Enter PAN Number"
        />
        {renderFieldError("panNumber")}
      </div>

      <div className="col-md-6">
        <label className="form-label csr-label">
  Registration Number <span style={{ color: "red" }}>*</span>
</label>
        <input
          type="text"
          className={getInputClass("registrationNumber")}
          name="registrationNumber"
          value={regData.registrationNumber}
          onChange={handleRegChange}
          placeholder="Enter Registration Number"
        />
        {renderFieldError("registrationNumber")}
      </div>
    </>
  )}


                    <div className="col-md-6 position-relative">
                    <label className="form-label csr-label">
  Password <span style={{ color: "red" }}>*</span>
</label>
                      <input
                        type={showRegPass ? "text" : "password"}
                        className={getInputClass("password")}
                        name="password"
                        value={regData.password}
                        onChange={handleRegChange}
                        placeholder="Create a password"

                      />
                      {renderFieldError("password")}
                      <span
                        className="auth-csr-eye"
                        onClick={() => setShowRegPass(!showRegPass)}
                      >
                        👁
                      </span>
                    </div>

                    <div className="col-md-6 position-relative">
                      <label className="form-label csr-label">
  Confirm Password <span style={{ color: "red" }}>*</span>
</label>
                      <input
                        type={showRegConf ? "text" : "password"}
                        className={getInputClass("confirmPassword")}
                        name="confirmPassword"
                        value={regData.confirmPassword}
                        onChange={handleRegChange}
                        placeholder="Re-enter password"
                      />
                      {renderFieldError("confirmPassword")}
                      <span
                        className="auth-csr-eye"
                        onClick={() => setShowRegConf(!showRegConf)}
                      >
                        👁
                      </span>
                    </div>

<div className="col-12">
  <div className="form-check">

    <input
      className={`form-check-input ${regErrors.agreeTerms ? "is-invalid" : ""}`}
      type="checkbox"
      name="agreeTerms"
      checked={regData.agreeTerms}
      onChange={handleRegChange}
      id="agreeTerms"
    />

    <label htmlFor="agreeTerms" className="form-check-label csr-muted">
      I agree to the <span className="auth-csr-link">Terms</span> &{" "}
      <span className="auth-csr-link">Privacy Policy</span>
    </label>

  </div>

  {/* IMPORTANT: keep error OUTSIDE form-check */}
  {regErrors.agreeTerms && (
    <div className="invalid-feedback d-block">
      {regErrors.agreeTerms}
    </div>
  )}
</div>

                    <div className="col-12">
                      <button className="auth-csr-btn w-100 btn">Create Account</button>
                    </div>

                    <div className="col-12 text-center">
                      <span className="auth-csr-muted">Already have an account? </span>
                      <span
                        className="auth-csr-link"

                        onClick={() => window.location.href = `${LOGIN_URL}`}

			>

                        Sign in
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>

      
      </div>
    );
  }
